import React,{createContext} from 'react';

const dbContext = createContext({});

export default dbContext